import { render } from "./AccountPlayer.vue?vue&type=template&id=077f2d28"
import script from "./AccountPlayer.vue?vue&type=script&lang=js"
export * from "./AccountPlayer.vue?vue&type=script&lang=js"

import "./AccountPlayer.vue?vue&type=style&index=0&id=077f2d28&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__